import React from 'react';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  /**
   * Each section draws the rule above itself instead of the panel interleaving
   * sibling `Divider`s. Sections decide for themselves whether they apply to the
   * current workflow, and one that returns early never renders this wrapper — so
   * it leaves no node to separate, and no orphan rule or empty gap behind it.
   *
   * Keyed off position rather than `& + &`, which silently dropped the rule: when
   * a caller passes a `className`, `cx` merges both emotion classes into a single
   * new one, so this class name is no longer in the DOM for a sibling selector to
   * match. This assumes a settings panel's scroll container holds only sections.
   */
  section: {
    '&:not(:first-child)': {
      borderTop: `1px solid ${theme.palette.divider}`,
      marginTop: theme.spacing(3),
      paddingTop: theme.spacing(3),
    },
  },
}));

interface SettingsSectionProps {
  children: React.ReactNode;
  className?: string;
}

/** One block of a settings panel, separated from its neighbours by a rule. */
export function SettingsSection({ children, className }: SettingsSectionProps): JSX.Element {
  const { classes, cx } = useStyles();

  return <div className={cx(classes.section, className)}>{children}</div>;
}
